import { connect } from 'react-redux';
import getContainer from './getContainer';

export default getContainer(connect);
